export enum VisitTypeEnum {
  IN_PERSON = 0,
  TELEHEALTH = 1,
  HOME_VISIT = 2,
  OTHER = 3,
}